import type { WireArticleBlock } from '../../../api/types'
import { PortionMark } from '../common/PortionMark'

type Block = Extract<WireArticleBlock, { type: 'heading' }>

export function HeadingBlock({ block }: { block: Block }) {
  const pm = <PortionMark classification={block.classification} disseminationControls={block.disseminationControls} />

  if (block.level === 1) {
    return (
      <h1 className="article-title text-fg">
        {pm}{block.content}
      </h1>
    )
  }
  if (block.level === 2) {
    return (
      <h2 className="article-heading-2 text-fg">
        {pm}{block.content}
      </h2>
    )
  }
  if (block.level === 3) {
    return (
      <h3 className="article-heading-3 text-fg">
        {pm}{block.content}
      </h3>
    )
  }
  return (
    <h4 className="article-heading-4 text-fg">
      {pm}{block.content}
    </h4>
  )
}
